import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import TrackContainer from "./TrackContainer";
import { selectRole } from "./infoSlice";
import { selectEventsData, setEventData } from "../events/eventsSlice";
import { useMemo } from "react";
import { EVENTS } from "../../analytics/events";
import { sendAnalyticsEvents } from "../../analytics/common";

const ReasonTrack = ({ history }) => {
  const { t } = useTranslation();
  const role = useSelector(selectRole)
  const dispatch = useDispatch();
  const eventsData = useSelector(selectEventsData);
  const reasonOptions = useMemo(() => {
    const commonOption = [{
      id: 0,
      imgPath: ('../assets/primary_reason/safety_concerns.png'),
      name: t("safety_concerns"),
      value: 'Safety'
    },
    {
      id: 1,
      imgPath: ('../assets/primary_reason/stay_connected.png'),
      name: t("stay_connected"),
      value: 'StayConncted'
    }];
  
    let options = [];
  
    switch (role) {
      case 'Partner':
        options = [
          {
            id: 0,
            imgPath: ('../assets/primary_reason/doubt.png'),
            name: t("doubt"),
            value: 'Doubt'
          },
          
        {
          id: 1,
          imgPath: ('../assets/primary_reason/stay_connected.png'),
          name: t("stay_connected"),
          value: 'StayConncted'
        },
        {
          id: 2,
          imgPath: ('../assets/primary_reason/safety_concerns.png'),
          name: t("safety_concerns"),
          value: 'Safety'
        }
        ];
        break;
      case 'Kid':
        options = [
          ...commonOption,
          {
            id: 2,
            imgPath: ('../assets/primary_reason/keep_kid_away.png'),
            name: t("keep_kid_away"),
            value: 'BadPlaces'
          },
           
        ];
        break;
      case 'Friend':
        options = [
          ...commonOption,
          {
            id: 2,
            imgPath: ('../assets/primary_reason/match_friend_location.png'),
            name: t("match_friends"),
            value: 'MeetOften'
          },
           
        ];
        break;
      case 'Grandparent':
        options = [
          ...commonOption,
          {
            id: 2,
            imgPath: ('../assets/primary_reason/prevent_lost.png'),
            name: t("prevent_lost"),
            value: 'PreventLost'
          },
        ];
        break;
      case 'Sibling':
      default:
        options = [
          ...commonOption,
        ];
        break;
    }
    const lastOption = {
      id: options.length + 1,
      imgPath: ('../assets/primary_reason/other.png'),
      name: t("other"),
      value: 'Other'
    };
    options.push(lastOption);
  
    return options;
  }, [t, role]);

  const onSingleClick = (reason) => {
    dispatch(setEventData({ id: 'Reason', data: reason }))
    sendAnalyticsEvents(EVENTS.onboardingReasonSubmitted, {
      ...eventsData,
      Reason: reason,
    })
    history.push(`/choose-time`);
  }

  return (
    <TrackContainer
      pageEvent={"onboardingReasonShown"}
      title={role === 'Other' ? t("question3_other") : t("question3_title", {role: role.toLowerCase()})}
      options={reasonOptions}
      onSingleClick={onSingleClick}
      nextPage={'choose-time'}
    />
  );
}

export default ReasonTrack;